// import api from "../common/apiClient";
// import SummaryApi from "../common/SummaryApi";

// /* ---------------- LOCAL CART ---------------- */

// const LOCAL_CART_KEY = "guest_cart";

// export const getLocalCart = () => {
//   try {
//     return JSON.parse(localStorage.getItem(LOCAL_CART_KEY)) || [];
//   } catch {
//     return [];
//   }
// };

// export const saveLocalCart = (cart) => {
//   localStorage.setItem(LOCAL_CART_KEY, JSON.stringify(cart));
// };

// export const addToLocalCart = ({ productId, variantId, sizeId, quantity }) => {
//   const cart = getLocalCart();

//   const existing = cart.find(
//     (i) => i.sizeId === sizeId
//   );

//   if (existing) {
//     existing.quantity += quantity || 1;
//   } else {
//     cart.push({
//       productId,
//       variantId,
//       sizeId,
//       quantity: quantity || 1
//     });
//   }

//   saveLocalCart(cart);
//   return cart;
// };

// /* ---------------- MAIN ADD TO CART ---------------- */

// export const addToCart = async ({
//   productId,
//   variantId,
//   sizeId,
//   quantity = 1,
//   token
// }) => {
//   // 🔹 GUEST USER
//   if (!token) {
//     addToLocalCart({ productId, variantId, sizeId, quantity });
//     return { mode: "guest" };
//   }

//   // 🔹 LOGGED IN USER
//   const res = await api({
//     method: SummaryApi.addToCart.method,
//     url: SummaryApi.addToCart.url,
//     data: { productId, variantId, sizeId, quantity }
//   });

//   return { mode: "server", cart: res.data.cart };
// };


import axios from "axios";
import api from "../common/apiClient";
import SummaryApi from "../common/SummaryApi";

const LOCAL_CART_KEY = "guest_cart";

/* ---------- LOCAL CART ---------- */

export const getLocalCart = () => {
  try {
    return JSON.parse(localStorage.getItem(LOCAL_CART_KEY)) || [];
  } catch {
    return [];
  }
};

export const saveLocalCart = (cart) => {
  localStorage.setItem(LOCAL_CART_KEY, JSON.stringify(cart));
};

export const addToLocalCart = ({ productId, variantId, sizeId, quantity }) => {
  const cart = getLocalCart();

  const existing = cart.find(i => i.sizeId === sizeId);

  if (existing) {
    existing.quantity += quantity || 1;
  } else {
    cart.push({ productId, variantId, sizeId, quantity: quantity || 1 });
  }

  saveLocalCart(cart);
  return cart;
};

/* ---------- UPDATE LOCAL CART QTY ---------- */
export const updateLocalCart = (sizeId, quantity) => {
  const cart = getLocalCart().map((item) =>
    item.sizeId === sizeId
      ? { ...item, quantity }
      : item
  );

  saveLocalCart(cart);
  return cart;
};

/* ---------- REMOVE FROM LOCAL CART ---------- */
export const removeFromLocalCart = (sizeId) => {
  const cart = getLocalCart().filter(
    (item) => item.sizeId !== sizeId
  );

  saveLocalCart(cart);
  return cart;
};


/* ---------- MAIN ADD TO CART ---------- */

export const addToCart = async ({
  productId,
  variantId,
  sizeId,
  quantity = 1,
  token
}) => {

  // 🟡 GUEST USER
  if (!token) {
    addToLocalCart({ productId, variantId, sizeId, quantity });
    return { mode: "guest" };
  }

  // 🟢 LOGGED IN USER
  const res = await axios({
    method: SummaryApi.addToCart.method,
    url: SummaryApi.addToCart.url,
    data: { productId, variantId, sizeId, quantity },
    headers: {
      Authorization: `Bearer ${token}`
    }
  });

  return { mode: "server", cart: res.data.cart };
};

export const mergeGuestCart = async (token) => {
  const guestCart = getLocalCart();

  if (!guestCart || guestCart.length === 0) return;

  try {
    for (const item of guestCart) {
      await api({
        method: SummaryApi.addToCart.method,
        url: SummaryApi.addToCart.url,
        data: item,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    }

    localStorage.removeItem("guest_cart");
  } catch (err) {
    console.error("Guest cart merge failed", err);
  }
};